[
    { "image": "dashboard", "name": "Dashboard" },
    { "image": "hazard", "name": "7 Day Hazards" },
    { "image": "forecast", "name": "Hourly Forecasts" },
    { "image": "observation", "name": "Observations" },
    { "image": "conductor_rail", "name": "Conductor Rail" },
    { "image": "freight", "name": "Freight Wind Warning" },
    { "image": "hot_running_rail_forecast", "name": "Hot Running Rail Forecast" },
    { "image": "icing_forecast", "name": "OLE Icing Forecast" },
    { "image": "coastal", "name": "Coastal" },
    { "image": "alert", "name": "Alerts" },
    { "image": "pat", "name": "Precipitation Analysis Tool (PAT)" },
    { "image": "radar", "name": "Radar Analysis" },
    { "image": "leaf", "name": "Adhesion & Leaf Fall" },
    { "image": "river", "name": "River Observations" },
    { "image": "crane", "name": "Site Specific Request" },
    { "image": "observation", "name": "Model Maps"},
    { "image": "archive", "name": "Archive Access" }
  ]
  